import { AxiosError } from "axios";
import { Store } from "vuex";
import { LanguagePackage, languageItem } from "./store/LanguagePackage";

export const getLanguageFields = async (vue: Vue, languageId?: number) => {
  let result;
  try {
    if (languageId) {
      result = await vue.$axios.get(`/language/${languageId}/items`);
    } else {
      result = await vue.$axios.get(`/language/items`);
    }

    const languagePackage: LanguagePackage = {
      itemsArray: result.data.fields,
      languageId: result.data.languageId,
      displayName: result.data.displayName
    };

    return languagePackage;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response && axiosError.response.status == 403)
      if (vue.$router.currentRoute.path !== "/login")
        vue.$router.push("/login");
  }
};

import * as Sentry from "@sentry/vue";

export const getField = (store: Store<any>, key: string): string => {
  if (Array.isArray(store.state.localLanguagePack?.itemsArray) === false)
    return "";

  if (store.state.localLanguagePack.itemsArray.length === 0) {
    return "";
  }

  const vuexItem = store.state.localLanguagePack.itemsArray?.find(
    (item: languageItem) => {
      return item.key === key;
    }
  );

  if (!vuexItem && process.env.NODE_ENV === "production") {
    Sentry.captureMessage(`Language key ${key} not found`, {
      level: "warning",
      extra: {
        languageId: store.state.localLanguagePack.languageId
      }
    });
  }

  return vuexItem ? vuexItem.value : key;
};
